'use strict';

import axios from 'axios';
import { customEvent } from '@jspartials/general-utils';

// Selectors
const selector = {
  arrivalDateMessage: '.js-arrival-date-message',
  storeDeliveryMessage: '.js-store-delivery-message'
};

// Elements
const element = {
  arrivalDateMessage: null,
  storeDeliveryMessage: null
};

// Functions

/**
 * Initializes the elements
 * @returns {void}
 */
const initElements = () => {
  element.arrivalDateMessage =
    document.querySelector(selector.arrivalDateMessage) || null;
  element.storeDeliveryMessage =
    document.querySelector(selector.storeDeliveryMessage) || null;
};

/**
 * Gets the message for the arrival date
 * @returns {void}
 */
const getMessageForArrivalDate = () => {
  if (element.arrivalDateMessage) {
    axios
      .post(globalVariables.endpoint.pdpGetMessageForArrivalDate)
      .then((response) => {
        const { data = {} } = response;
        const { htmlMessage = '' } = data;

        element.arrivalDateMessage.innerHTML = htmlMessage;
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

/**
 * Gets the message for the store delivery
 * @returns {void}
 */
const getMessageForStoreDelivery = () => {
  if (element.storeDeliveryMessage) {
    const productId = element.storeDeliveryMessage?.dataset?.productId || '';

    if (!productId) {
      return;
    }

    axios
      .post(
        globalVariables.endpoint.pdpGetMessageForStoreDelivery,
        {
          productId
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then((response) => {
        const { data = {} } = response;
        const { htmlMessage = '' } = data;

        element.storeDeliveryMessage.innerHTML = htmlMessage;
        document.dispatchEvent(new CustomEvent(customEvent.sidebar.init));
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

const initShippingMethodMessages = () => {
  initElements();
  getMessageForArrivalDate();
  getMessageForStoreDelivery();
};

export { initShippingMethodMessages };
